import {
    Accordion,
    AccordionDetails,
    AccordionSummary, Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField, Tooltip, Typography,
    useTheme
} from "@mui/material";
import {DatePicker} from "@mui/x-date-pickers";
import IconButton from "@mui/material/IconButton";
import{DeleteRounded, ExpandMoreRounded, InfoRounded, LibraryAddRounded} from "@mui/icons-material";
import * as React from "react";
import {useTranslation} from "react-i18next";
import dayjs from "dayjs";
import {Control, Controller} from "react-hook-form";
import {ReactComponentElement} from "react";
import {FieldArrayWithId} from "react-hook-form/dist/types/fieldArray";

interface SubPeriodsProps {
    title: string | ReactComponentElement<any>,
    startDate: Date | null | undefined,
    endDate: Date | null |undefined,
    control: Control<any>,
    remove: Function,
    append:Function,
    fields: FieldArrayWithId[],
    watch:Function,
    errors : any,
    fieldName: string
}


const SubPeriods = ({ startDate, endDate, control, append, remove, title, fields, watch, errors, fieldName} :SubPeriodsProps) => {
    const theme = useTheme();
    const accentColor = theme.palette.accent.main;
    const {t} = useTranslation(['salesmarketing', 'translation']);
    const [expanded, setExpanded] = React.useState<boolean>(false);

    const allDatesSelected = () : boolean=>{
        let res = true;
        watch(fieldName).forEach((sp:any)=>{
            if(sp.startDate === null || sp.endDate ===null)
                res = false;
        })
        return res;
    }

    React.useEffect(()=>{
        if(errors.hasOwnProperty(fieldName))
            setExpanded(true);
    },[errors])

    return (
        <Accordion
            expanded={expanded}
            onChange={()=>{
                if(!errors.hasOwnProperty(fieldName))
                {
                    setExpanded((prev:boolean)=> !prev);
                }
            }}
            >
            <AccordionSummary
                expandIcon={<ExpandMoreRounded/>}
                aria-controls="subperiods-content"
                id="superiods-header"
            >
                <Typography>{title}</Typography>
            </AccordionSummary>
            <AccordionDetails>
                {(watch(fieldName) && !allDatesSelected() || (!startDate || !endDate)) &&
                    <Tooltip sx={{float: "right"}}
                             title={(!startDate || !endDate) ? t('promo.createForm.defineStartEndDatePromo') : (watch(fieldName) && !allDatesSelected()) ? t('promo.createForm.defineStartEndDateSubPeriod') : ""}>
                        <InfoRounded color={"primary"}/>
                    </Tooltip>
                }
                <Button
                    disabled={(watch(fieldName) && !allDatesSelected() || (!startDate || !endDate))}
                    sx={{float: "right"}} variant={"text"} color={"accent"}
                    endIcon={<LibraryAddRounded/>} onClick={()=>{append({startDate:null, endDate:null})}}>
                    {t('subPeriods.add')}
                </Button>
                {fields && fields.length > 0 &&
                    <TableContainer sx={{paddingTop: "10px"}}>
                        <Table aria-label="subPeriods-table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>{t('subPeriods.startDate')}</TableCell>
                                    <TableCell>{t('subPeriods.endDate')}</TableCell>
                                    <TableCell>{t('subPeriods.delete')}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {fields.map((item:any, index: number) => (
                                    <TableRow
                                        key={"sub" + index}
                                    >
                                        <TableCell>
                                            <Controller
                                                control={control}
                                                name={`${fieldName}.${index}.startDate`}
                                                render={({field, fieldState}) => (
                                                    <DatePicker
                                                        minDate={startDate ? startDate : null}
                                                        maxDate={watch(`${fieldName}.${index}.endDate`) ? watch(`${fieldName}.${index}.endDate`) : endDate}
                                                        //label={t('salesmarketing:promo.subPeriods.startDate')}
                                                        value={field.value}
                                                        onChange={(d) => {
                                                            field.onChange(dayjs(d).startOf("day").toDate());
                                                        }}
                                                        renderInput={(params) =>
                                                            <TextField
                                                                required
                                                                {...params}
                                                                style={{width: "50%"}}
                                                                fullWidth
                                                                name="startDate"
                                                                error={!!fieldState.error}
                                                                helperText={fieldState.error?.message}
                                                            />}
                                                        inputFormat={"L"}
                                                    />
                                                )}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <Controller
                                                control={control}
                                                name={`${fieldName}.${index}.endDate`}
                                                render={({field, fieldState}) => (
                                                    <DatePicker
                                                        maxDate={endDate ? endDate : null}
                                                        minDate={watch(`${fieldName}.${index}.startDate`) ? watch(`${fieldName}.${index}.startDate`) : startDate}
                                                        //label={t('salesmarketing:promo.subPeriods.startDate')}
                                                        value={field.value}
                                                        onChange={(d) => {
                                                            field.onChange(dayjs(d).endOf("day").toDate());
                                                        }}
                                                        renderInput={(params) =>
                                                            <TextField
                                                                required
                                                                {...params}
                                                                style={{width: "50%"}}
                                                                fullWidth
                                                                name="startDate"
                                                                error={!!fieldState.error}
                                                                helperText={fieldState.error?.message}
                                                            />}
                                                        inputFormat={"L"}
                                                    />
                                                )}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <IconButton
                                                aria-label="close"
                                                onClick={() => remove(index)}
                                            >
                                                <DeleteRounded sx={{color: accentColor}}/>
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                }
            </AccordionDetails>
        </Accordion>
    )
}

export default SubPeriods